/**
 * 刘伟 2020-01-04 11:50
 * @description 配置文件:用于配置相关参数，如网络请求地址、其他配置等!
 */
const config = {};

/**
 * 构建类型 微信 还是普通web
 */
config.BUILD_TYPE = process.env.VUE_APP_BUILD_TYPE;

// config.API_BASE_URL = 'http://192.168.99.166:9000/';
config.API_BASE_URL = process.env.VUE_APP_BASE_URL;

/**
 * api请求超时
 */
config.API_NORMAL_TIMEOUT = 1000 * 30;

/**
 * 请求成功codeww
 */
config.API_SUCCESS_CODE = 1;

/**
 * 请求错误code
 */
config.API_ERROR_COLDE = 0;

/**
 * 没权限401 code
 */
config.API_NOT_PERMISSION_CODE = 401;

/**
 * 登录占用 code
 */
config.API_OCCUPATION_CODE = 4001;

/**
 * 分页条数
 */
config.PAGE_ITEMS = 10;

/**
 * 税务百分比
 */
config.TAX_NUMBER = 13;

/**
 * 七牛云图片链接
 */
config.QINIU_URL = process.env.VUE_APP_QINIU_URL;

/**
 * 百度地图key
 */
config.MAP_KEY = "kpisfppyVBEVEpLZjV1zm1GyDhGVfAnQ";

/**
 * 微信appid
 */
config.WECHAT_APPID = process.env.VUE_APP_WECHAT_APPID;

/**
 *  当前域名
 */
config.WEB_DOMAIN_NAME = process.env.VUE_APP_WEB_DOMAIN_NAME;

/**
 * 百度地图中心点
 */
config.MAP_CENTER = {
    lng: 114.0914659067, //经度
    lat: 22.5475448426, //维度
};

config.BANK_INFO = {
    company: "深圳市油柑科技有限公司",
    account: "4000 0221 0920 0744 484",
    address: "中国工商银行股份有限公司深圳华强支行",
    value: "4000022109200744484",
};

config.WAREHOUSE_ADDRESS_INFO = {
    detailsAddress: "广东省深圳市龙岗区上李朗智创园1栋5楼",
    addressName: "李朗仓库",
    addressTel: "13430457019",
}

/**
 * 百度地图缩放大小
 */
config.MAP_ZOOM = 15;

export default config;
